/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Carriedoutsusworkshopmentalstrength6Inputs */

const de__field_carriedoutsusworkshopmentalstrength6 = /** @type {(inputs: _Field_Carriedoutsusworkshopmentalstrength6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchgeführt SuS-Workshop Mental Strength`)
};

/**

* @param {_Field_Carriedoutsusworkshopmentalstrength6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_carriedoutsusworkshopmentalstrength6 = /** @type {((inputs?: _Field_Carriedoutsusworkshopmentalstrength6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Carriedoutsusworkshopmentalstrength6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_carriedoutsusworkshopmentalstrength6(inputs)
});
export { _field_carriedoutsusworkshopmentalstrength6 as "_field_carriedOutSuSWorkshopMentalStrength" }